export const SHOW_PROMPT_DIALOG = 'app/SHOW_PROMPT_DIALOG';
export const CLOSE_PROMPT_DIALOG = 'app/CLOSE_PROMPT_DIALOG';
